// alternative-dashboard\mappers\useTopBeneficiariesData.ts
import { useEffect, useState } from "react";
import { fetchTopBeneficiariesGraph } from "./topBeneficiariesDataSource";
import { mapTopBeneficiariesResponse } from "./topBeneficiariesMapper";
import type { TopBeneficiaryDisplayItem } from "../types/topBeneficiaries";

interface UseTopBeneficiariesDataResult {
  data: TopBeneficiaryDisplayItem[];
  loading: boolean;
  error: string | null;
}

export const useTopBeneficiariesData = (): UseTopBeneficiariesDataResult => {
  const [data, setData] = useState<TopBeneficiaryDisplayItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const load = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetchTopBeneficiariesGraph();
        if (!isMounted) return;

        if (response.status === 1) {
          setData(mapTopBeneficiariesResponse(response.data));
        } else {
          setError(response.errorMessage || "Failed to load top beneficiaries");
        }
      } catch (err) {
        if (isMounted) {
          setError(
            err instanceof Error
              ? err.message
              : "Failed to load top beneficiaries",
          );
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    load();
    return () => {
      isMounted = false;
    };
  }, []);

  return { data, loading, error };
};
